import darkThemePalette from "./dark.theme.palette";
import { getTheme } from "../themes.service";

const darkTheme = getTheme(darkThemePalette);

export default darkTheme;
